export default __webpack_public_path__ + "static/media/loading.94581833.svg";